<template>
    <transition name="fade">
        <div v-if="show && coords"
             :class="['visual-tooltip', {'visual-tooltip_with_angle': angle},
                `is-${directionPretty}`, data && data.modify ? `visual-tooltip_is_${data.modify}` : '' ]"
             :style="{top: `${y}px`, left: `${x}px`}"
             ref="wrapper">

            <template>
                <component v-if="component" :is="component" :tooltip="data.tooltip"/>
            </template>
        </div>
    </transition>
</template>

<script>
import Bus from '../../Bus';
import TooltipParking from './TooltipParking.vue';

export default {
    components: {
        TooltipParking
    },

    data: () => {
        return {
            component: null,
            angle    : true,
            wrapper  : null,
            show     : false,
            coords   : {},
            data     : {
                tooltip  : null,
                modify   : '',
                offset   : 20,
                direction: 'under'
            }
        };
    },

    watch: {
        show(val) {
            if (!val) {
                return;
            }

            this.$nextTick(() => {
                this.wrapper = this.$refs.wrapper;
            });
        }
    },

    computed: {
        directionPretty() {
            if (!this.wrapper) {
                return '';
            }

            const direction = this.data.direction;
            const path = direction === 'over' || direction === 'under' ? 2 : 1;

            // Не влезает по правому краю.
            if (window.innerWidth - this.coords.x < (this.wrapper.offsetWidth / path) + this.data.offset) {
                return 'left';
            }

            // Не влезает по левому краю.
            if (this.coords.x < (this.wrapper.offsetWidth / path) + this.data.offset) {
                return 'right';
            }

            // Не влезает по верхнему краю.
            if (this.coords.y < this.wrapper.offsetHeight + this.data.offset) {
                return 'under';
            }

            // Не влезает по нижнему краю.
            if (window.innerHeight - this.coords.y < this.wrapper.offsetHeight + this.data.offset) {
                return 'over';
            }

            return direction || 'over';
        },

        x() {
            if (!this.wrapper) {
                return 0;
            }

            switch (this.directionPretty) {
                case 'over': return this.coords.x - (this.wrapper.offsetWidth / 2);
                case 'under': return this.coords.x - (this.wrapper.offsetWidth / 2);
                case 'left': return this.coords.x - this.wrapper.offsetWidth - this.data.offset;
                case 'right': return this.coords.x + this.data.offset;
                default: return this.coords.x - (this.wrapper.offsetWidth / 2);
            }
        },

        y() {
            if (!this.wrapper) {
                return 0;
            }

            switch (this.directionPretty) {
                case 'over': return this.coords.y - this.wrapper.offsetHeight - this.data.offset;
                case 'under': return this.coords.y + this.data.offset;
                case 'left': return this.coords.y - (this.wrapper.offsetHeight / 2);
                case 'right': return this.coords.y - (this.wrapper.offsetHeight / 2);
                default: return this.coords.y - this.wrapper.offsetHeight - this.data.offset;
            }
        }
    },

    methods: {
        setShow(show) {
            this.show = show;
        },

        setData(data) {
            this.component = this.getComponentByType(data.type);
            this.data = {
                ...this.data,
                tooltip: data.tooltip || null,
                modify : data.modify || '',
                offset : typeof data.offset === 'number' ? data.offset : 20
            };
        },

        getComponentByType(type) {
            switch (type) {
                case 'complex': return 'TooltipComplex';
                case 'parking': return 'TooltipParking';
                case 'flat': return 'TooltipFlat';
                case 'infrastructure': return 'TooltipInfrastructure';
                default: return 'TooltipStandard';
            }
        },

        setCoords(coords) {
            this.coords = coords;
        }
    },

    mounted() {
        Bus.$on('tooltip:show', this.setShow);
        Bus.$on('tooltip:data', this.setData);
        Bus.$on('tooltip:coords', this.setCoords);
    },

    beforeDestroy() {
        Bus.$off('tooltip:show', this.setShow);
        Bus.$off('tooltip:data', this.setData);
        Bus.$off('tooltip:coords', this.setCoords);
    }
};
</script>
